/**
 * Shared form validation for personal data
 *
 * This is used on the application form, personal data form and the change password form
 */

export function onFieldChanged(field) {
  const tag = field.tagName;
  if (tag == 'SELECT' || (tag == 'INPUT' && field.type != 'radio')) {
    if (field.value) {
      field.classList.add('with-value')
      field.classList.remove('invalid-value');
    } else {
      field.classList.remove('with-value');
    }
  }

  if (field.value) {
    field.classList.remove('untouched');
  }
}

export function onFieldUpdated(field, validateFieldFn, forceValidation) {
  // No validation if the field is still pristine
  if (forceValidation || !field.classList.contains('untouched')) {
    // Validate the field
    var isValid = validateFieldFn(field);
    if (!isValid) {
      field.classList.remove('with-value')
      field.classList.add('invalid-value');
    } else {
      field.classList.remove('invalid-value');
    }
  }
}
export default {
  onFieldChanged,
  onFieldUpdated
}
